import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  EventEmitter,
  TemplateRef
} from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material";
import { Router, ActivatedRoute } from "@angular/router";
import { PropertiesDialogComponent } from "./properties-dialog/properties-dialog.component";
import { ToastService } from "ng-uikit-pro-standard";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppConfig } from "src/app/config";
import { GUID } from "./../../guid";
import { DataService } from "src/app/data.service";
import { EmptySectionComponent } from "../empty-section/empty-section.component";
import { TranslationService } from "src/app/translation.service";
import { log } from "util";

@Component({
  selector: "app-field-layout",
  templateUrl: "./field-layout.component.html",
  styleUrls: ["./field-layout.component.scss"]
})
export class FieldLayoutComponent implements OnInit {
  @ViewChild("translateDialog", { static: false })
  translateDialog!: TemplateRef<any>;

  @ViewChild("translateGroupDialog", { static: false })
  translateGroupDialog!: TemplateRef<any>;
  translateGroupDialogRef: MatDialogRef<any>;
  sectionsData: { sectionName: string; translategroup: any[] }[] = [];

  layoutgrouplabel = [];
  isDataLoaded = false;
  showElements1: boolean = true;
  showElements2: boolean = true;
  newSection: any;
  sectionName: string;
  detailPage: boolean;
  editPage: boolean;
  column: number;
  imageSection: boolean;
  systemSection: boolean;
  sectionCounter: number = 1;
  inputField: any[] = [];
  sectionList: any[] = [];
  droppedDataFieldList: any[] = [];
  droppedDataButtonList: any[] = [];
  droppedDataRelatedList: any[] = [];
  droppedButtonDataRelatedList: any[] = [];
  layoutButton: any[] = [];
  relatedFields: any[] = [];
  newRelatedlayout: any;
  groupfieldAttributes: any = {};
  groupFields: any = {};
  propertiesField: any = {};
  visible: boolean;
  hidden: false;
  islink: false;
  headerfields: false;
  hiddenonnew: false;
  hiddenonedit: false;
  sequence: 0;
  linkfield: "";
  linkrelativeurl: "";
  object: "";
  recordtypeexist: false;
  lockedonedit: false;
  lockedonnew: false;
  // autofillsource: "";
  isLoading = false;
  isError = false;
  errorMessage = "";
  profileId = "";
  metaobjectId = " ";
  metaobjectName = "";
  metalayoutId = "";
  metalayoutName = "";
  displayName = "";
  editDisplayName = "";
  Name = "";
  fieldHistory = false;
  approvalHistory = false;
  activity = false;
  notesandattachments = false;
  processBarType = "";
  followup = false;
  Team = false;
  pathSetting = false;
  publicAccess = false;
  mode = "New";
  category = "";
  devicetype = "";
  sinceversionseq = 0;
  deprecatedversionseq = 0;

  guid: GUID;
  // metalayout;
  // metarelatedlayout: any[] = [];
  metaLayoutGroupId = "";
  metaProfileLayoutWebId = "";
  metaRelatedLayoutId = "";
  metaRelatedViewLayoutId = "";
  metaLayoutGroupIdSection = "";
  metaProfileLayouts = [];
  metaProfileLayoutWebs = [];
  recordTypes = [];
  queues = [];
  queueList = [];
  fields = [];
  fieldList = [];
  operatorList = [];
  picklistValueList = [];
  fieldsToDo = [];
  fieldsDone = [];

  detailForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",
    username: "",
    id: "",
    name: "",
    publicaccess: false,
    active: true,
    attributes: {},
    targeturl: "",
    columncount: 2,
    tabkeyorder: "L-R",
    hascustomview: false,
    clonable: false,
    editable: true,
    deletable: false,
    haskanbanview: true,
    searchtext: "",
    sortby: "createdon",
    sortorder: "desc"
  });
  @ViewChild("componentContainer", { read: ViewContainerRef, static: false })
  componentContainer!: ViewContainerRef;
  @ViewChild("componentContainer1", { read: ViewContainerRef, static: false })
  componentContainer1!: ViewContainerRef;
  @ViewChild("childComponentRef", { read: ViewContainerRef, static: false })
  childComponentRef: ViewContainerRef;

  @ViewChild(PropertiesDialogComponent, { static: false })
  propertiesDialog: PropertiesDialogComponent;
  @ViewChild(EmptySectionComponent, { static: false })
  emptySectionComponent: EmptySectionComponent;

  // @Input() sectionProperties: any;
  @Input() GroupfieldAttributes: any;

  @Output() retrievedProperties: EventEmitter<any> = new EventEmitter<any>();
  languages: any[];
  data: any;
  translatedLabels: any;
  dialogRef: any;
  dialogRefTranslation: any;
  datas: any;
  dialogRefGroupTranslation: any;
  translatedGroupLabels: any;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private dialog: MatDialog,
    private router: Router,
    private toastrService: ToastService,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private route: ActivatedRoute,
    private dataService: DataService,
    private translationService: TranslationService
  ) {}
  translateForm: FormGroup;
  translateGroupForm: FormGroup;

  ngOnInit() {
    this.guid = new GUID();
    this.visible = true;

    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      this.metaLayoutGroupId = this.route.snapshot.params.metagroupid;

      this.retrieveMetaFields();
      this.retrieveMetabuttons();

      if (this.mode.toLocaleLowerCase().trim() == "edit") {
        // this.retrieveMetaFields();
        // this.retrieveMetabuttons();
        this.metalayoutId = this.route.snapshot.params.id;
        this.metalayoutName = this.route.snapshot.params.metalayoutname;
        this.metaobjectId = this.route.snapshot.params.metaobjectid;
        // this.retrieveSavedData();
        // this.retrieveRelatedlayout();
      }

      this.profileId = this.route.snapshot.params.profileid;
      //always convert string to boolean while assigning to formcontrol ****
      var boolValue = this.route.snapshot.params.publicaccess == "true";
      this.publicAccess = boolValue;
    });

    console.log("mode", this.mode);

    if (this.mode.toLocaleLowerCase().trim() == "new") {
      // this.retrieveMetaFields();
      // this.retrieveMetabuttons();
      const defaultSection = {
        id: this.generateUniqueId(),
        sectionName: "New Section",
        detailPage: false,
        editPage: false,
        imageSection: false,
        systemSection: false,

        column: 2,
        droppedDataFieldList: []
      };
      console.log("mode!", this.mode);
      this.sectionList.push(defaultSection);
    }
    this.translateForm = this.fb.group({
      translate: this.fb.array([]),
      code: "",
      language: ""
    });

    this.translateGroupForm = this.fb.group({
      translategroup: this.fb.array([]),
      code: "",
      language: ""
    });
    // Initialize with one language by default
    this.addLang();
    this.addGroupLang();
    this.getLanguage();
    this.getTranslationLabelById();
  }

  getLanguage() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    // this.isDataLoaded = false;

    this.dataService
      .getOrgLanguage(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allLanguages = res.data.orglanguage;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allLanguages.length; i++) {
              objArr.push({
                value: allLanguages[i].code,
                label: allLanguages[i].language
              });
            }
            this.languages = objArr;

            // this.isLoading = false;
          } else {
            console.log("error while retrieving");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  selectedGroupLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }

  translatedGroupText: string = "";

  get translategroup(): FormArray {
    return this.translateGroupForm.get("translategroup") as FormArray;
  }

  addGroupLang() {
    console.log("Grouplang");
    const translateSectionGroup = this.fb.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required]
    });

    this.translategroup.push(translateSectionGroup);
  }

  // translatorgroup(index: number) {
  //   const translateSectionGroup = this.translategroup.at(index) as FormGroup;
  //   const selectedLanguage = translateSectionGroup.get("languageCode").value;
  //   const labelname = this.datas.labelname;

  //   console.log(selectedLanguage);

  //   this.translationService
  //     .translate(labelname, selectedLanguage, "en")
  //     .subscribe((response: any) => {
  //       const translatedGroupText =
  //         response.data.translations[0].translatedGroupText;
  //       translateSectionGroup
  //         .get("translatedName")
  //         .setValue(translatedGroupText);
  //     });
  // }
  translatorgroup(index: number) {
    const translateSectionGroup = this.translategroup.at(index) as FormGroup;
    const selectedLanguage = translateSectionGroup.get("languageCode").value;
    const labelname = this.datas.sectionName;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedGroupText =
          response.data.translations[0].translatedGroupText;
        translateSectionGroup
          .get("translatedName")
          .setValue(translatedGroupText);
      });
  }

  // saveGroupTranslated() {
  //   // console.log(this.translateForm);
  //   if (this.translateGroupForm.valid) {
  //     // Handle the form submission
  //     console.log(
  //       "Saving form data:",
  //       this.translateGroupForm.value.translategroup
  //     );

  //     this.translatedGroupLabels = this.translateGroupForm.value.translategroup;
  //   }
  //   this.translateGroupDialogRef.close();
  // }
  // saveGroupTranslated() {
  //   if (this.translateGroupForm.valid) {
  //     console.log(
  //       "Saving form data:",
  //       this.translateGroupForm.value.translategroup
  //     );

  //     // Save form data to sectionsData
  //     const existingSectionIndex = this.sectionsData.findIndex(
  //       (section) => section.sectionName === this.datas.sectionName
  //     );
  //     if (existingSectionIndex !== -1) {
  //       this.sectionsData[existingSectionIndex].translategroup =
  //         this.translateGroupForm.value.translategroup;
  //     } else {
  //       this.sectionsData.push({
  //         sectionName: this.datas.sectionName,
  //         translategroup: this.translateGroupForm.value.translategroup,
  //       });
  //     }
  //   }
  //   this.translateGroupDialogRef.close();
  // }
  saveGroupTranslated() {
    if (this.translateGroupForm.valid) {
      console.log(
        "Saving form data:",
        this.translateGroupForm.value.translategroup
      );

      // Save form data to sectionsData
      const existingSectionIndex = this.sectionsData.findIndex(
        (section) => section.sectionName === this.datas.sectionName
      );
      if (existingSectionIndex !== -1) {
        this.sectionsData[existingSectionIndex].translategroup =
          this.translateGroupForm.value.translategroup;
      } else {
        this.sectionsData.push({
          sectionName: this.datas.sectionName,
          translategroup: this.translateGroupForm.value.translategroup
        });
      }
    }
    this.translateGroupDialogRef.close();
  }

  removeGroupLang(index: number) {
    this.translategroup.removeAt(index);
  }

  openTranslateGroupDialog(sectionName: any): void {
    console.log("labelname", sectionName);

    if (!sectionName) {
      return;
    }

    // Reset the form and clear previous data
    this.translateGroupForm = this.fb.group({
      translategroup: this.fb.array([]),
      code: "",
      language: ""
    });

    // Populate form with existing data if available
    const sectionData = this.sectionsData.find(
      (section) => section.sectionName === sectionName
    );
    if (sectionData) {
      sectionData.translategroup.forEach((group) => {
        const translateSectionGroup = this.fb.group({
          languageCode: [group.languageCode, Validators.required],
          translatedName: [group.translatedName, Validators.required]
        });
        this.translategroup.push(translateSectionGroup);
      });
    }

    this.datas = { sectionName: sectionName };

    this.translateGroupDialogRef = this.dialog.open(this.translateGroupDialog, {
      height: "400px",
      width: "800px",
      data: this.datas
    });

    this.translateGroupDialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
        // Handle any post-dialog actions if needed
        this.saveGroupTranslated();
      }
    });
  }

  getTranslationLabelById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metalayoutlabeltranslation: {
          metalayoutid: this.metalayoutId
        }
      }
    };

    this.isLoading = true;
    // this.isDataLoaded = false;

    this.dataService.getLayoutTranslationLabelById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.layoutgrouplabel =
            res.data.metalayouttranslation.metalayoutgrouplabeltranslation;

          // Loop through the response and add translation fields
          if (res.data.metalayouttranslation.metalayoutlabeltranslation) {
            this.translate.clear();
            res.data.metalayouttranslation.metalayoutlabeltranslation.forEach(
              (translation) => {
                const translateGroup = this.fb.group({
                  languageCode: [translation.languagecode, Validators.required],
                  translatedName: [
                    translation.translatedlabel,
                    Validators.required
                  ]
                });
                this.translate.push(translateGroup);
              }
            );
            // After populating translateForm, update translatedLabels
            this.translatedLabels =
              res.data.metalayouttranslation.metalayoutlabeltranslation.map(
                (translation) => ({
                  languageCode: translation.languagecode,
                  translatedName: translation.translatedlabel
                })
              );
          }

          // this.translateGroupForm.setControl(
          //   "translategroup",
          //   this.fb.array([])
          // );

          // if (res.data.metalayouttranslation.metalayoutgrouplabeltranslation) {
          //   res.data.metalayouttranslation.metalayoutgrouplabeltranslation.forEach(
          //     (translation) => {
          //       const translateGroup = this.fb.group({
          //         languageCode: [translation.languagecode, Validators.required],
          //         translatedName: [
          //           translation.translatedlabel,
          //           Validators.required,
          //         ],
          //       });
          //       this.translategroup.push(translateGroup);
          //     }
          //   );

          //   // Update sectionsData with metalayoutgrouptranslation data
          //   const sectionName = "System Information"; // Set the section name appropriately
          //   const existingSectionIndex = this.sectionsData.findIndex(
          //     (section) => section.sectionName === sectionName
          //   );
          //   if (existingSectionIndex !== -1) {
          //     this.sectionsData[existingSectionIndex].translategroup =
          //       res.data.metalayouttranslation.metalayoutgrouplabeltranslation.map(
          //         (translation) => ({
          //           languageCode: translation.languagecode,
          //           translatedName: translation.translatedlabel,
          //         })
          //       );
          //   } else {
          //     this.sectionsData.push({
          //       sectionName: sectionName,
          //       translategroup:
          //         res.data.metalayouttranslation.metalayoutgrouplabeltranslation.map(
          //           (translation) => ({
          //             languageCode: translation.languagecode,
          //             translatedName: translation.translatedlabel,
          //           })
          //         ),
          //     });
          //   }
          // }
          // console.log(
          //   res.data.metalayouttranslation.metalayoutgrouplabeltranslation
          // );
          // console.log(this.translateGroupForm.get("translategroup").value);
          // console.log(this.sectionsData);

          // this.isLoading = false;
        } else {
          console.log("no data");
          // this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        // this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  selectedLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }

  translatedText: string = "";

  get translate(): FormArray {
    return this.translateForm.get("translate") as FormArray;
  }

  addLang() {
    const translateGroup = this.fb.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required]
    });

    this.translate.push(translateGroup);
  }

  translator(index: number) {
    const translateGroup = this.translate.at(index) as FormGroup;
    const selectedLanguage = translateGroup.get("languageCode").value;
    const labelname = this.data.labelname;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedText = response.data.translations[0].translatedText;
        translateGroup.get("translatedName").setValue(translatedText);
      });
  }
  saveTranslated() {
    // console.log(this.translateForm);
    if (this.translateForm.valid) {
      // Handle the form submission
      console.log("Saving form data:", this.translateForm.value.translate);

      this.translatedLabels = this.translateForm.value.translate;
    }
    // this.dialogRef.close();
    // if (this.dialogRef) {
    this.dialogRefTranslation.close();

    // this.dialog.close()
    // }
  }
  removeLang(index: number) {
    this.translate.removeAt(index);
  }

  // @Input() set openDialog(open: boolean) {
  //   console.log("Test2");
  //   if (open) {
  //     this.dialog.open(this.translateDialog);
  //   }
  // }

  // @Input()
  // set openDialog(open: boolean) {
  //   console.log("Open Dialog:", open);
  //   if (open) {
  //     this.dialog.open(this.translateDialog);
  //   }
  // }

  showAppField = true;
  showAppButtonLayout = false;
  showAppRelatedList = false;

  // Function to handle the click event for "Fields" and "Buttons."
  toggleComponent(componentName: string) {
    this.showAppField = componentName === "Fields";
    this.showAppButtonLayout = componentName === "Buttons";
    this.showAppRelatedList = componentName === "Related";

    // if (this.showAppField) {
    //   this.router.navigateByUrl("fields/");
    // }
  }

  retrieveMetaFields() {
    return new Promise((resolve, reject) => {
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metafield: {
            metaobjectid: this.metaobjectId
          }
        }
      };
      this.isLoading = true;
      this.isDataLoaded = false;

      this.dataService.getMetaFields(postOption).subscribe(
        (response: any) => {
          console.log("fields response:", response);

          if (response !== null && response.success == 1) {
            const fields = response.data.metafields;

            for (let i = 0; i < fields.length; i++) {
              var field = fields[i];

              //skip id type fields if there
              if (field.fieldtype.toLowerCase() == "id") continue;

              //skip fields with visibility false
              if (field.visible == false) continue;

              //skip fields deleted, ownertype etc.,
              if (
                field.fieldname.toLowerCase() == "deleted" ||
                field.fieldname.toLowerCase() == "ownertype" ||
                field.fieldname.toLowerCase() == "migrated" ||
                field.fieldname.toLowerCase() == "organizationid" ||
                field.fieldname.toLowerCase() == "internalid" ||
                // field.fieldname.toLowerCase() == "academic_year" ||
                // field.fieldname.toLowerCase() == "academic_session" ||
                // field.fieldname.toLowerCase() == "institution" ||
                field.fieldname.toLowerCase() == "institution_id" ||
                field.fieldname.toLowerCase() == "systemmodstamp" ||
                field.fieldname.toLowerCase() == "search" ||
                field.fieldname.toLowerCase() == "date_range"
              )
                continue;

              if (field.tenantfield == true) continue;

              //skip converted field if object is lead
              if (
                this.metaobjectName.toLowerCase().trim() == "lead" &&
                field.fieldname.toLowerCase() == "converted"
              )
                continue;

              if (field.attributes.ignorablefield == true) continue;

              field.dropped = false;
              this.inputField.push(field);
            }
            // this.isLoading = false;
            if (this.mode.toLocaleLowerCase() == "edit") {
              this.retrieveSavedData();
              this.retrieveRelatedlayout();
            } else {
              this.isDataLoaded = true;
              this.isLoading = false;
            }
          } else {
            console.log("No data!");
            this.errorMessage =
              response != null ? response.message : "No data!";
            this.isError = true;
            // this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  // retrieveMetabuttons() {
  //   return new Promise((resolve, reject) => {
  //     console.log("getMetabuttons");

  //     let postOption = {
  //       organizationid: localStorage.getItem("crm_orgid"),
  //       userid: localStorage.getItem("crm_userid"),
  //       username: localStorage.getItem("crm_username"),
  //       data: {
  //         // sortfield: this.sorting.fieldName,
  //         // sortorder: this.sorting.order,
  //         metabutton: {
  //           metaobjectid: this.metaobjectId,
  //         },
  //       },
  //     };
  //     console.log("postOption", postOption);
  //     this.isLoading = true;
  //     this.dataService.getMetaButtonsLayout(postOption).subscribe(
  //       (res) => {
  //         console.log("res", res);
  //         const layoutButtons = res.data.metabuttons;

  //         for (let i = 0; i < layoutButtons.length; i++) {
  //           var button = layoutButtons[i];

  //           button.dropped = false;
  //           this.layoutButton.push(button);
  //         }

  //         if (res !== null && res.success == 1) {
  //           this.isLoading = false;
  //           resolve(null);
  //         } else {
  //           console.log("No metabuttons data!");
  //           this.errorMessage =
  //             res != null ? res.message : "No metabuttons data!";
  //           this.isError = true;
  //           this.isLoading = false;
  //           resolve(null);
  //         }
  //       },
  //       (err) => {
  //         console.log("Error***:", err);
  //         this.errorMessage = err.message;
  //         this.isError = true;
  //         this.isLoading = false;
  //         resolve(null);
  //       }
  //     );
  //   });
  // }

  retrieveRelatedlayout() {
    console.log("retrieveRelatedlayout");
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metarelatedlayout: {
          parentobjectid: this.metaobjectId,
          metalayoutid: this.metalayoutId
        }
      }
    };
    console.log("postoption edit", postOption);
    this.isLoading = true;
    // this.isDataLoaded = false;

    this.dataService
      .getMetaRelatedlayout(postOption)
      .subscribe((response: any) => {
        console.log("response:", response);
        if (response.message == "No rows found") {
          console.log("No rows Found");
        } else {
          const metarelatedlayouts = response.data.metarelatedlayout;
          const metarelatedViewlayouts = response.data.metarelatedviewlayout;

          if (metarelatedlayouts) {
            console.log("metarelatedlayout", metarelatedlayouts);
            const mappedrelated = metarelatedlayouts.map(
              (metarelatedlayout) => {
                const selectedLookupFields = [];
                const selectedLookupButtons = [];

                metarelatedlayout.metarelatedlayoutfield
                  .sort((a, b) => a.sequence - b.sequence)
                  .forEach((field) => {
                    if (field.metarelatedlayoutid === metarelatedlayout.id) {
                      selectedLookupFields.push(field);
                    }
                  });

                metarelatedlayout.metarelatedlayoutbutton
                  .sort((a, b) => a.sequence - b.sequence)
                  .forEach((button) => {
                    if (button.metarelatedlayoutid === metarelatedlayout.id) {
                      selectedLookupButtons.push(button);
                    }
                  });

                this.newRelatedlayout = {
                  metaobjectid: metarelatedlayout.metaobjectid,
                  metaobjectname: metarelatedlayout.metaobjectname,
                  location: metarelatedlayout.location,
                  viewtype: metarelatedlayout.viewtype,
                  sortfield: metarelatedlayout.sortfield,
                  sortorder: metarelatedlayout.sortorder,
                  uploadtype: metarelatedlayout.uploadtype,
                  enableversioning: metarelatedlayout.enableversioning,
                  linkedobject: metarelatedlayout.linkedobject,
                  contrafield: metarelatedlayout.contrafield,
                  contrareferencefields:
                    metarelatedlayout.contrareferencefields,

                  // relatedlistflag: metarelatedlayout.attributes.relatedlistflag,
                  relatedgroupname: metarelatedlayout.relatedgroupname,

                  iconname: metarelatedlayout.iconname,
                  fieldid: metarelatedlayout.fieldid,
                  fieldname: metarelatedlayout.fieldname,
                  childrelationshipname: metarelatedlayout.name,
                  relatedlistlabel: metarelatedlayout.labelname,
                  attributes: metarelatedlayout.attributes,
                  referencefieldname: metarelatedlayout.referencefieldname,
                  selectedLookupButtons: selectedLookupButtons,
                  selectedLookupFields: selectedLookupFields,
                  selectedViewFields: [],
                  selectedViewButtons: [],
                  layoutsequence: metarelatedlayout.layoutsequence
                };

                console.log(this.newRelatedlayout);

                this.droppedDataRelatedList.push(this.newRelatedlayout);

                console.log("metarelatedlayout Pushed");
              }
            );

            const mappedviewrelated = metarelatedViewlayouts.map(
              (metarelatedviewlayout) => {
                const selectedViewFields = [];
                const selectedViewButtons = [];

                console.log(metarelatedviewlayout);

                console.log(metarelatedviewlayout.metarelatedviewlayoutfield);

                metarelatedviewlayout.metarelatedviewlayoutfield
                  .sort((a, b) => a.sequence - b.sequence)
                  .forEach((field) => {
                    if (
                      field.metarelatedlayoutid ===
                      metarelatedviewlayout.metarelatedlayoutid
                    ) {
                      selectedViewFields.push(field);
                    }
                  });

                metarelatedviewlayout.metarelatedviewlayoutbutton
                  .sort((a, b) => a.sequence - b.sequence)
                  .forEach((button) => {
                    if (
                      button.metarelatedlayoutid ===
                      metarelatedviewlayout.metarelatedlayoutid
                    ) {
                      selectedViewButtons.push(button);
                    }
                  });

                const currentRelatedLayout = this.droppedDataRelatedList.find(
                  (relatedLayout) =>
                    relatedLayout.metaobjectid ===
                    metarelatedviewlayout.metaobjectid
                );

                if (currentRelatedLayout) {
                  currentRelatedLayout.selectedViewFields = selectedViewFields;
                  currentRelatedLayout.selectedViewButtons =
                    selectedViewButtons;
                }
                // this.newRelatedlayout.selectedViewFields = selectedViewFields;
                // this.newRelatedlayout.selectedViewButtons = selectedViewButtons;

                console.log(this.droppedDataRelatedList);
                console.log("metarelatedlayout Pushed");
              }
            );
            // return mappedSections;
          }
          this.droppedDataRelatedList.sort(function (a, b) {
            // console.log("gfdgfdgdf", a);
            // console.log("gfdgfdgdf", b);
            return parseInt(a.layoutsequence) - parseInt(b.layoutsequence);

            // return a.layoutsequence - b.layoutsequence; // Adjust the property based on which you want to sort
          });
        }
        // this.isLoading = false;
        // this.isDataLoaded = true;
      });
  }

  retrieveSavedData() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      // attributes: {
      //   relatedlistflag: false,
      //   notesandattachments: false,
      //   activity: false,
      // },
      data: {
        metalayout: {
          id: this.metalayoutId,
          action: "layout",
          mode: this.mode,
          name: this.metalayoutName,
          metaobjectid: this.metaobjectId,
          metagroupid: this.metaLayoutGroupId,
          embeddedobject: false
        }
      }
    };
    console.log("postoption edit", postOption);
    this.isLoading = true;
    this.isDataLoaded = false;

    this.dataService.getMetalayoutByName(postOption).subscribe(
      (response: any) => {
        console.log("response:", response);

        console.log(response.data.metalayout.name);

        this.Name = response.data.metalayout.name;
        this.displayName = response.data.metalayout.displayname;
        this.editDisplayName = response.data.metalayout.editdisplayname;
        this.fieldHistory = response.data.metalayout.fieldhistory;
        this.approvalHistory = response.data.metalayout.approvalhistory;
        this.activity = response.data.metalayout.attributes.activity;
        this.notesandattachments =
          response.data.metalayout.attributes.notesandattachments;
        this.followup = response.data.metalayout.attributes.followup;
        this.processBarType =
          response.data.metalayout.attributes.processbartype;

        this.Team = response.data.metalayout.team;
        this.pathSetting = response.data.metalayout.pathsetting;
        this.category = response.data.metalayout.category;
        this.devicetype = response.data.metalayout.devicetype;
        this.sinceversionseq = response.data.metalayout.sinceversionseq;
        this.deprecatedversionseq =
          response.data.metalayout.deprecatedversionseq;
        // this.groupfieldattributes =
        const sections = response.data.metalayout.metalayoutgroups;
        const sectionfields = response.data.metalayout.metalayoutgroupfields;
        const buttons = response.data.metalayout.metalayoutbuttons;
        const groupproperties = response.data.metalayout.metalayoutgroupfields;
        this.metaProfileLayouts = response.data.metalayout.metaprofilelayouts;
        this.metaProfileLayoutWebs =
          response.data.metalayout.metaprofilelayoutwebs;

        console.log(buttons);
        // Create an array to hold the mapped properties
        const mappedProperties = [];
        groupproperties.forEach((property: any) => {
          // Assuming fieldDataObject is an empty object or initialized appropriately
          var fieldData = {};

          fieldData[property.fieldname] = property;
          mappedProperties.push(fieldData);
          // Emit the property here
          this.retrievedProperties.emit(mappedProperties);
          // console.log("mapped properties",fieldDataObject[property.fieldname])
        });

        if (sections) {
          console.log("Sections", sections);
          const mappedSections = sections.map((section) => {
            const newSection = {
              id: section.id,
              sectionName: section.name,
              detailPage: section.showondetailpage,
              editPage: section.showoneditpage,
              onnew: section.onnew != null ? section.onnew : true,
              onedit: section.onedit != null ? section.onedit : true,
              imageSection: section.imagesection,
              systemSection: section.systemsection,
              column: parseInt(section.columncount),
              groupsequence: section.groupsequence,
              droppedDataFieldList: []
            };

            const mappedSectionFields = sectionfields.map((sectionfield) => {
              if (sectionfield.metagroupid == section.id) {
                const fields = this.inputField.map((field) => {
                  if (sectionfield.metafieldid == field.id) {
                    // sectionfield.primaryfield = field.primaryfield;
                    // sectionfield.visibility = field.visibility;
                    // sectionfield.defaultvalue = field.defaultvalue;
                    field.dropped = true;
                    const sectionFieldAttributes =
                      sectionfield.attributes || {};
                    field.attributes = {
                      ...sectionFieldAttributes,
                      hiddenonnew:
                        sectionFieldAttributes.hiddenonnew != null
                          ? sectionFieldAttributes.hiddenonnew
                          : false,
                      hiddenonedit:
                        sectionFieldAttributes.hiddenonedit != null
                          ? sectionFieldAttributes.hiddenonedit
                          : false,
                      onnew:
                        sectionFieldAttributes.onnew != null
                          ? sectionFieldAttributes.onnew
                          : true,
                      onedit:
                        sectionFieldAttributes.onedit != null
                          ? sectionFieldAttributes.onedit
                          : true
                    };
                    newSection.droppedDataFieldList.push(field);

                    // console.log("Field",field)
                    this.groupfieldAttributes[field.fieldname] =
                      field.attributes;

                    this.groupFields[field.fieldname] = sectionfield;

                    // this.groupfieldattributes = field.attributes;
                    // console.log("groupfieldattributes",this.groupfieldattributes)
                    // field.push(groupproperties)
                  }
                });
                // newSection.droppedDataFieldList.push(sectionfield);
              }
            });

            this.sectionList.push(newSection);

            console.log("Section Pushed", this.sectionList);

            console.log("Section Pushed");

            this.translateGroupForm.setControl(
              "translategroup",
              this.fb.array([])
            );

            if (this.layoutgrouplabel) {
              // Filter translations for the current section
              const sectionTranslations = this.layoutgrouplabel.filter(
                (translation) => translation.metalayoutgroupid === section.id
              );

              sectionTranslations.forEach((translation) => {
                const translateGroup = this.fb.group({
                  languageCode: [translation.languagecode, Validators.required],
                  translatedName: [
                    translation.translatedlabel,
                    Validators.required
                  ]
                });
                this.translategroup.push(translateGroup);
              });

              // Update sectionsData with metalayoutgrouptranslation data
              const existingSectionIndex = this.sectionsData.findIndex(
                (s) => s.sectionName === section.name
              );

              if (existingSectionIndex !== -1) {
                this.sectionsData[existingSectionIndex].translategroup =
                  sectionTranslations.map((translation) => ({
                    languageCode: translation.languagecode,
                    translatedName: translation.translatedlabel
                  }));
              } else {
                this.sectionsData.push({
                  sectionName: section.name,
                  translategroup: sectionTranslations.map((translation) => ({
                    languageCode: translation.languagecode,
                    translatedName: translation.translatedlabel
                  }))
                });
              }
            }
            console.log(this.layoutgrouplabel);
            console.log(this.translateGroupForm.get("translategroup").value);
            console.log(this.sectionsData);
          });
          // return mappedSections;
          this.sectionList.sort(function (a, b) {
            // console.log("aaaaaaaaa", b);
            return a.groupsequence - b.groupsequence; // Adjust the property based on which you want to sort
          });
        }

        // if (buttons) {
        //   console.log("buttons", buttons);
        //   buttons.forEach((metalayoutbutton) => {
        //     metalayoutbutton.dropped = true;

        //     this.droppedDataButtonList.push(metalayoutbutton);
        //   });
        //   console.log("droppedDataButtonList", this.droppedDataButtonList);

        //   this.droppedDataButtonList.sort(function (a, b) {
        //     console.log("gfdgfdgdf", a);
        //     return a.buttonsequence - b.buttonsequence; // Adjust the property based on which you want to sort
        //   });
        // }

        const mappedSectionFields = buttons.map((lbutton) => {
          const fields = this.layoutButton.map((butto) => {
            // console.log(lbutton);
            // console.log(butto);

            if (lbutton.metabuttonid == butto.id) {
              butto.dropped = true;
              butto.buttonsequence = lbutton.buttonsequence; // Add buttonsequence to butto
              this.droppedDataButtonList.push(butto);
            }
          });
          // console.log(this.droppedDataButtonList);
          this.droppedDataButtonList.sort(function (a, b) {
            // console.log("gfdgfdgdf", a);
            return a.buttonsequence - b.buttonsequence; // Adjust the property based on which you want to sort
          });
          // newSection.droppedDataFieldList.push(sectionfield);
        });
        this.isLoading = false;
        this.isDataLoaded = true;
      },
      (error: any) => {
        console.error("Error retrieving saved data:", error);
        this.errorMessage = error.message;
        this.isError = true;
        this.isLoading = true;
      }
    );
  }

  retrieveMetabuttons() {
    return new Promise((resolve, reject) => {
      console.log("getMetabuttons");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          // sortfield: this.sorting.fieldName,
          // sortorder: this.sorting.order,
          metabutton: {
            metaobjectid: this.metaobjectId
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      // this.isDataLoaded = false;

      this.dataService.getMetaButtons(postOption).subscribe((res) => {
        console.log("res", res);

        if (res !== null && res.success == 1) {
          // this.layoutButton = res.data.metabuttons;
          this.layoutButton = res.data.metabuttons.filter(
            (metabutton) => metabutton.actiontype !== "CustomView"
          );

          // this.isLoading = false;
          // layoutbuttons.dropped = false;
          // this.layoutButton.push(layoutbuttons);
        }
      });
    });
  }

  delete1() {
    this.showElements1 = !this.showElements1;
    console.log("Number Deleted");
  }

  hiddenIndex: number = -1;

  samp = "Sample Text";
  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  onSectionDrag(event: DragEvent) {
    event.dataTransfer.setData("text/plain", "Section");
    console.log("Mode", this.mode);
    // console.log("column", this.column);
  }
  onSectionDragStart(event: DragEvent, section: any) {
    event.dataTransfer.setData("text/plain", JSON.stringify(section));
  }

  onSectionDragOver(event: DragEvent) {
    event.preventDefault();
  }

  generateUniqueId(): string {
    return Math.random().toString(36).substr(2, 9);
  }

  handleSectionPropertiesChanged(properties: any, index: number) {
    this.sectionName = properties.sectionName;
    this.detailPage = properties.detailPage;
    this.editPage = properties.editPage;
    this.imageSection = properties.imageSection;
    this.systemSection = properties.systemSection;
    this.column = properties.column;

    if (index >= 0 && index < this.sectionList.length) {
      const section = this.sectionList[index];
      section.sectionName = properties.sectionName;
      section.detailPage = properties.detailPage;
      section.editPage = properties.editPage;
      section.onnew = properties.onnew;
      section.onedit = properties.onedit;
      section.imageSection = properties.imageSection;
      section.systemSection = properties.systemSection;
      section.column = properties.column;
    }

    console.log("handleSectionPropertiesChanged", properties);
    console.log("Updated sectionList:", this.sectionList);
    return this.sectionList;
  }

  handleFieldPropertiesChanged(properties: any) {
    const propertiesfield = {
      readonly: properties.properties.readonly,
      required: properties.properties.required
    };

    this.propertiesField[properties.fieldname] = propertiesfield;
    console.log("propertiesfield", propertiesfield);
  }

  handleGroupAttributesChanged(properties: any, fieldname: any) {
    const groupfieldattributes = {
      hidden: properties.attributes.hidden,
      islink: properties.attributes.islink,
      headerfields: properties.attributes.headerfields,
      hiddenonnew:
        properties.attributes.hiddenonnew != null
          ? properties.attributes.hiddenonnew
          : false,
      hiddenonedit:
        properties.attributes.hiddenonedit != null
          ? properties.attributes.hiddenonedit
          : false,
      onnew: properties.attributes.onnew != null ? properties.attributes.onnew : true,
      onedit: properties.attributes.onedit != null ? properties.attributes.onedit : true,
      linkfield: properties.attributes.linkfield,
      linkrelativeurl: properties.attributes.linkrelativeurl,
      sequence: properties.attributes.sequence,
      object: properties.attributes.object,
      recordtypeexist: properties.attributes.recordtypeexist,
      lockedonedit: properties.attributes.lockedonedit,
      lockedonnew: properties.attributes.lockedonnew
      // autofillsource: properties.attributes.autofillsource,
    };
    this.groupfieldAttributes[properties.fieldname] = groupfieldattributes;

    console.log("handleGroupAttributesChanged", this.groupfieldAttributes);
    console.log(
      "handleGroupAttributesChanged__fieldname",
      properties.fieldname
    );
    console.log("groupfieldattributes", groupfieldattributes);

    return groupfieldattributes;
  }

  handleFieldsDone(fieldsDone) {
    console.log("Received FieldsDone in the parent component", fieldsDone);

    this.relatedFields = fieldsDone.map((item) => {
      const selectedLookupFields = item.selectedLookupFields.flat();
      const selectedLookupButtons = item.selectedLookupButtons.flat();
      const selectedViewFields = item.selectedViewFields;
      const selectedViewButtons = item.selectedViewButtons;
      const relatedFilters = item.relatedFilters;

      // const fieldName = item.lookupfield.fieldname || item.fieldname;
      // const fieldId = item.lookupfield.fieldid || item.fieldid;

      const fieldName = item.fieldname || item.lookupfield.fieldname;
      const ReferenceName =
        item.referencefieldname || item.lookupfield.referencefieldname;
      const fieldId = item.fieldid || item.lookupfield.fieldid;
      const RelatedLayoutName =
        item.childrelationshipname ||
        item.lookupfield.attributes.childrelationshipname;
      const RelatedLayoutLabelName =
        item.relatedlistlabel || item.lookupfield.attributes.relatedlistlabel;
      const attributes = item.attributes || item.lookupfield.attributes;

      return {
        metaobjectid: item.metaobjectid,
        label: item.label,
        metaobjectname: item.metaobjectname,
        description: item.description,
        location: item.location,

        viewtype: item.viewtype,
        sortfield: item.sortfield,
        sortorder: item.sortorder,
        uploadtype: item.uploadtype,
        enableversioning: item.enableversioning,
        linkedobject: item.linkedobject,
        contrafield: item.contrafield,
        contrareferencefields: item.contrareferencefields,
        relatedgroupname: item.relatedgroupname,

        iconname: item.iconname,
        fieldname: fieldName,
        referencefieldname: ReferenceName,
        fieldid: fieldId,
        childrelationshipname: RelatedLayoutName,
        attributes: attributes,
        relatedlistlabel: RelatedLayoutLabelName,
        selectedLookupFields: selectedLookupFields,
        selectedLookupButtons: selectedLookupButtons,
        selectedViewFields: selectedViewFields,
        selectedViewButtons: selectedViewButtons,
        relatedFilters: relatedFilters || []
      };
    });

    // Logging the resulting array
    console.log(this.relatedFields);
    this.droppedDataRelatedList = this.relatedFields;
  }

  onSectionDrop(event: DragEvent) {
    event.preventDefault();
    const droppedData = event.dataTransfer.getData("text/plain");
    if (droppedData === "Section") {
      const newSection = {
        id: this.generateUniqueId(),
        sectionName: "New Section",
        detailPage: true,
        editPage: false,
        imageSection: false,
        systemSection: false,
        column: 2,
        droppedDataFieldList: []
      };

      this.sectionList.push(newSection);
      console.log("Empty Section Created");
      console.log("Section Id:", newSection.id);
      console.log("Updated sectionList:", this.sectionList);
      console.log("Updated sectionList:", newSection);

      return newSection;
    }
    // return null;
  }

  onSectionDrops(event: DragEvent, newIndex: number) {
    event.preventDefault();
    const droppedIndex = Number(event.dataTransfer.getData("text/plain"));
    if (droppedIndex && droppedIndex !== newIndex) {
      const section = this.sectionList[droppedIndex];
      this.sectionList.splice(droppedIndex, 1);
      this.sectionList.splice(newIndex, 0, section);
      console.log("index", droppedIndex);
    }
  }

  handleDroppedDataEvent(data: any) {
    console.log("handleDroppedDataEvent", data);
    const sectionId = data.sectionId;
    const droppedfield = data.field;
    console.log("Field Data", droppedfield);

    const fields = this.inputField.map((field) => {
      // console.log("!!!!!!!!!!!!field", field);

      if (droppedfield.id == field.id) {
        field.dropped = true;
      }
    });
    console.log("droppedDataFieldList!!!", this.droppedDataFieldList);
  }

  handleFieldDeleted(deletedfield) {
    console.log("deletedfield", deletedfield.id);
    const fields = this.inputField.map((field) => {
      console.log("field", field.id);

      if (deletedfield.id == field.id) {
        field.dropped = false;
      }
    });
  }

  handleDroppedButtonEvent(button: any) {
    console.log("handleDroppedButtonEvent", button);

    // this.droppedDataButtonList.push(button);
    const droppedbutton = button;
    console.log("Button Data", droppedbutton);

    // const buttons = this.layoutButton.map((buttonss) => {
    //   console.log("droppedDataButton 000000000000", buttonss);

    //   console.log("droppedDataButtonList id *********", buttonss.id);
    //   console.log("button id ****", button.id);
    // if (button.id == buttonss.id) {
    //   button.dropped = true;
    // }

    const fields = this.layoutButton.map((button) => {
      console.log("!!!!!!!!!!!!field", button);

      if (droppedbutton.id == button.id) {
        button.dropped = true;
      }
    });

    // });

    console.log("droppedDataButtonList!!!", this.droppedDataButtonList);
  }

  handleButtonDeleted(deletedbutton) {
    console.log("deletedbutton", deletedbutton.id);
    const fields = this.layoutButton.map((button) => {
      console.log("field", button.id);

      if (deletedbutton.id == button.id) {
        button.dropped = false;
      }
    });
  }

  handleDroppedLookupButtonEvent(button: any) {
    console.log("handleDroppedLookupButtonEvent", button);

    const droppedlookupbutton = button;
    console.log("Lookup Data", droppedlookupbutton);

    const fields = this.droppedButtonDataRelatedList.map((button) => {
      if (droppedlookupbutton.id == button.id) {
        button.dropped = true;
      }

      console.log(droppedlookupbutton.id);
      console.log(button.id);
    });
    console.log(
      "droppedButtonDataRelatedList!!!",
      this.droppedButtonDataRelatedList
    );
  }

  handleDroppedLookupEvent(field: any) {
    console.log("handleDroppedLookupEvent", field);
    const droppedlookup = field;
    console.log("Lookup Data", droppedlookup);

    const fields = this.droppedDataRelatedList.map((field) => {
      console.log(field.metaobjectid);
      console.log(droppedlookup[0].metaobjectid);
      if (droppedlookup[0].metaobjectid == field.metaobjectid) {
        field.dropped = true;
      }

      console.log(droppedlookup[0].metaobjectid);
      console.log(field.metaobjectid);
    });
    console.log("droppedDataRelatedList!!!", this.droppedDataRelatedList);
  }

  handleLookupFieldDeleted(deletedfield) {
    console.log("deletedfield", deletedfield.metaobjectid);
    const fields = this.droppedDataRelatedList.map((field) => {
      console.log("field", field.metaobjectid);

      if (deletedfield.metaobjectid == field.metaobjectid) {
        field.dropped = false;
      }
    });
  }

  handleSectionDeleted(index: number): void {
    this.sectionList.splice(index, 1);
    console.log("index", index);
    console.log("sectionList", this.sectionList);
  }

  onDragOver2(event: DragEvent) {
    event.preventDefault();
  }

  properties(): void {
    let dialogRef = this.dialog.open(PropertiesDialogComponent, {
      data: {
        displayname: this.displayName,
        editdisplayname: this.editDisplayName,
        name: this.Name,
        fieldhistory: this.fieldHistory,
        approvalhistory: this.approvalHistory,
        activity: this.activity,
        notesandattachments: this.notesandattachments,
        followup: this.followup,
        processbartype: this.processBarType,
        team: this.Team,
        pathsetting: this.pathSetting,
        category: this.category,
        devicetype: this.devicetype,
        sinceversionseq:
          this.sinceversionseq != null ? this.sinceversionseq : 0,
        deprecatedversionseq:
          this.deprecatedversionseq != null ? this.deprecatedversionseq : 0,
        mode: this.mode
      },
      height: "420px",
      width: "700px"
    });

    this.propertiesDialog = dialogRef.componentInstance;
    this.propertiesDialog.setParent(this);

    dialogRef.componentInstance.openTranslateDialog.subscribe(
      (open: boolean) => {
        this.openTranslateDialog(open);
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Properties dialog was closed");
    });
  }
  openTranslateDialog(open: boolean): void {
    console.log("Open Translate Dialog:", open);
    if (open) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = "560px"; // Set the width
      dialogConfig.height = "400px"; // Set the height
      // this.dialog.open(this.translateDialog,dialogConfig);
      this.dialogRefTranslation = this.dialog.open(
        this.translateDialog,
        dialogConfig
      );
    }
  }

  // openTranslateGroupDialog(sectionName: any): void {
  //   console.log("labelname", sectionName);

  //   if (!sectionName) {
  //     return;
  //   }

  //   // this.translateGroupForm.patchValue({ label: sectionName });
  //   // this.datas = {
  //   //   labelname: sectionName,
  //   // };

  //   // this.translateGroupDialogRef = this.dialog.open(this.translateGroupDialog, {
  //   //   data: this.datas,
  //   //   height: "400px",
  //   //   width: "800px",
  //   // });

  //   this.translateGroupDialogRef  = this.dialog.open(this.translateGroupDialog, {
  //     // Pass data to the dialog
  //           height: "400px",
  //     width: "800px",
  //     data: { sectionName: sectionName }
  //   });

  //   this.translateGroupDialogRef.afterClosed().subscribe((result: any) => {
  //     console.log("The dialog was closed.");
  //     if (result) {
  //     }
  //   });
  // }
  cancel() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }

  receiveEnteredName(
    name: string,
    displayname: string,
    editdisplayname: string,
    fieldhistory: boolean,
    approvalhistory: boolean,
    activity: boolean,
    notesandattachments: boolean,
    followup: boolean,
    team: boolean,
    pathsetting: boolean,
    processbartype: string,
    category: string,
    devicetype: string,
    sinceversionseq: number,
    deprecatedversionseq: number
  ) {
    this.displayName = displayname;
    this.editDisplayName = editdisplayname;
    this.Name = name;
    this.approvalHistory = approvalhistory;
    this.activity = activity;
    this.notesandattachments = notesandattachments;
    this.followup = followup;
    this.processBarType = processbartype;
    this.fieldHistory = fieldhistory;
    this.Team = team;
    this.pathSetting = pathsetting;
    this.category = category;
    this.devicetype = devicetype;
    this.sinceversionseq = sinceversionseq;
    this.deprecatedversionseq = deprecatedversionseq;
    console.log("Name:", name);
    console.log("Entered Name:", displayname);
    console.log("approvalHistory:", approvalhistory);
    console.log("followup", followup);
    console.log("fieldhistory:", fieldhistory);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  postOption: any[] = [];

  save() {
    let noError = true;
    var metaGroupField = {
      metaobjectid: this.metaobjectId,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      metagroupid: this.metaLayoutGroupId
    };

    console.log("metaGroupField:", metaGroupField);

    var layoutName = this.sectionList.map((items) => {
      console.log("layoutName", items);
      return items;
    });

    console.log("Saved Data:", layoutName);

    this.isLoading = false;
    this.isError = false;

    if (this.displayName) {
    } else {
      this.showWarning("Name is mandatory");
      noError = false;
    }

    if (this.editDisplayName) {
    } else {
      this.showWarning("Edit LabelName is mandatory");
      noError = false;
    }

    console.log("layout data:", layoutName);

    if (layoutName.length == 0) {
      this.showWarning("You must have atleast one field in the selected list");
      noError = false;

      return;
    }

    if (this.droppedDataButtonList.length == 0) {
      this.showWarning("You must have atleast one button in the layout");
      noError = false;

      return;
    }

    layoutName.forEach((item) => {
      Name = item["fieldname"];
      return item;
    });

    var Name = this.Name;

    // this.metalayoutName = viewName;

    this.metalayoutName = this.Name;

    var targetURL = "api/v1/" + this.metaobjectName + "/metalayout/new";

    if (this.relatedFields.length > 0) {
      var metalayoutAttributes = {
        relatedlistflag: true,
        notesandattachments: this.notesandattachments,
        processbartype: this.processBarType,

        activity: this.activity,
        followup: this.followup,
        processflag: true,
        category: this.category,
        devicetype: this.devicetype,
        sinceversionseq:
          this.sinceversionseq != null ? this.sinceversionseq : 0,
        deprecatedversionseq:
          this.deprecatedversionseq != null ? this.deprecatedversionseq : 0
      };
    } else {
      var metalayoutAttributes = {
        relatedlistflag: false,
        followup: this.followup,

        notesandattachments: this.notesandattachments,
        activity: this.activity,
        processbartype: this.processBarType,
        processflag: true,
        category: this.category,
        devicetype: this.devicetype,
        sinceversionseq:
          this.sinceversionseq != null ? this.sinceversionseq : 0,
        deprecatedversionseq:
          this.deprecatedversionseq != null ? this.deprecatedversionseq : 0
      };
    }

    console.log("mode", this.mode);
    if (this.mode == "new") {
      this.metalayoutId = this.guid.getGUID("metalayout");
    }

    var hasRecordType = this.recordTypes.length > 0 ? true : false;

    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profileid: userDetail.profileid,
      profilename: userDetail.profilename,
      data: {
        metalayout: {
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          embeddedobject: false,
          parentobjectid: "",
          relatedobjectid: "",
          hasrecordtype: hasRecordType,
          mode: this.mode,
          id: this.metalayoutId,
          // displayname: save_data [0] ['labelname'],
          displayname: this.displayName,
          editdisplayname: this.editDisplayName,
          viewname: this.displayName,
          name: this.metalayoutName,
          fieldhistory: this.fieldHistory,
          team: this.Team,
          pathsetting: this.pathSetting,
          followup: this.followup,
          approvalhistory: this.approvalHistory,
          action: "New",
          layouttype: "Page Layout",
          // action: 'customview',
          targeturl: targetURL,
          columncount: this.detailForm.controls["columncount"].value,
          // columncount: this.column,
          tabkeyorder: this.detailForm.controls["tabkeyorder"].value.trim(),
          hascustomview: this.detailForm.controls["hascustomview"].value,
          clonable: this.detailForm.controls["clonable"].value,
          editable: this.detailForm.controls["editable"].value,
          deletable: this.detailForm.controls["deletable"].value,
          haskanbanview: this.detailForm.controls["haskanbanview"].value,
          searchtext: this.detailForm.controls["searchtext"].value.trim(),
          sortby: this.detailForm.controls["sortby"].value.trim(),
          sortorder: this.detailForm.controls["sortorder"].value.trim(),
          pagesize: this.appConfig.appDefaultPageSize,
          category: this.category,
          devicetype: this.devicetype,
          sinceversionseq:
            this.sinceversionseq != null ? this.sinceversionseq : 0,
          deprecatedversionseq:
            this.deprecatedversionseq != null ? this.deprecatedversionseq : 0,
          pagenumber: 1,
          userid: localStorage.getItem("crm_userid"),
          // publicaccess: this.detailForm.controls["publicaccess"].value,
          publicaccess: true,
          // filterbyowner: this.criteriaForm.controls['filterbyowner'].value.trim(),
          // queueid: this.criteriaForm.controls['queueid'].value.trim(),
          // queuename: this.criteriaForm.controls['queuename'].value.trim(),
          filterbyowner: "",
          queueid: "",
          queuename: "",
          active: true,
          attributes: metalayoutAttributes,
          metalayoutbuttonsprovided: true,
          metaprofilelayouts: [],
          // metaprofilelayoutcriterias: [],
          metalayoutgroups: [],
          metaprofilelayoutwebs: [],
          metalayoutbuttons: [],
          layoutlabeltranslation: [],
          layoutgrouplabeltranslation: [] //will be served at server
        },
        metarelatedlayout: [],
        metarelatedviewlayout: []
      }
    };
    console.log("postOption", postOption);
    //****** metaprofilelayout  *********/

    var metaProfileLayoutId = "";
    //metaprofilelayout
    metaProfileLayoutId = this.guid.getGUID("metaprofilelayout");
    console.log("metaprofileLayoutId:", metaProfileLayoutId);

    var metaProfileLayout = {
      id: metaProfileLayoutId,
      metaobjectid: this.metaobjectId,
      embeddedobject: false,
      parentobjectid: "",
      metalayoutid: this.metalayoutId,
      recordtypeid: "",
      profileid: "",
      description: "",
      actiontype: "New",
      layouttype: "Page Layout",
      metalayoutname: this.metalayoutName,
      active: true,
      attributes: {}
    };
    // console.log("metaProfileLayout", metaProfileLayout);

    //push metaprofilelayout to request data (postoption)

    // if (this.mode.toLocaleLowerCase() == "new") {
    //   postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);
    // } else {
    //   postOption.data.metalayout.metaprofilelayouts = this.metaProfileLayouts;
    // }

    if (this.mode.toLocaleLowerCase() === "new") {
      postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);
    } else {
      if (this.metaProfileLayouts && this.metaProfileLayouts.length > 0) {
        postOption.data.metalayout.metaprofilelayouts = this.metaProfileLayouts;
      } else {
        postOption.data.metalayout.metaprofilelayouts.push(metaProfileLayout);
      }
    }
    //     const sanitizedMetaProfileLayouts = this.metaProfileLayouts.map(
    //   (item) => ({
    //     ...item,
    //     layoutjsontext: {},
    //     fieldjsontext: {},
    //     criteriajsontext: {},
    //   })
    // );

    // // Assign sanitized array to the payload
    // postOption.data.metalayout.metaprofilelayoutwebs =
    //   sanitizedMetaProfileLayoutWebs;

    //***Done***//

    //****** metalayoutgroup  *********/

    //get metalayoutgroup details and assign it to postoption

    this.metaLayoutGroupId = this.guid.getGUID("metalayoutgroup");

    var groupSequence = 1;

    if (this.sectionList) {
      this.sectionList.forEach((section) => {
        this.metaLayoutGroupIdSection = this.guid.getGUID("metalayoutgroup");
        var metaLayoutGroup = {
          id: this.metaLayoutGroupIdSection,
          // id: this.guid.getGUID("metalayoutgroup" ),
          metaobjectid: this.metaobjectId,
          embeddedobject: false,
          parentobjectid: "",
          metalayoutid: this.metalayoutId,
          name: section.sectionName,
          groupsequence: groupSequence,
          showondetailpage: section.detailPage,
          showoneditpage: section.editPage,
          onnew: section.onnew != null ? section.onnew : true,
          onedit: section.onedit != null ? section.onedit : true,
          imagesection: section.imageSection,
          systemsection: section.systemSection,
          columncount: section.column,
          active: true,
          metalayoutgroupfields: []
        };
        groupSequence++;

        var index = 1;

        section.droppedDataFieldList.forEach((droppedField: any) => {
          var metaGroupField = {
            id: this.guid.getGUID("metalayoutgroupfield"),
            metaobjectid: this.metaobjectId,
            embeddedobject: false,
            parentobjectid: "",
            metalayoutid: this.metalayoutId,
            metagroupid: this.metaLayoutGroupIdSection,
            metafieldid: droppedField.id,
            fieldname: droppedField.fieldname,
            fieldtype: droppedField.fieldtype,
            labelname: droppedField.labelname,
            // fieldattributes: droppedField.attributes,
            attributes: {},
            supportingobjectid: "",
            supportingfield: false,
            standard: droppedField.standard,
            fieldsequence: index,
            defaultvalue: droppedField.defaultvalue,
            hinttext: droppedField.hinttext,
            helptext: droppedField.helptext,
            // required: droppedField.required,
            primary: droppedField.primaryfield,
            // visible: droppedField.visibility,
            visible: true,
            readonly: false,
            // readonly:this.readonly,
            required: false,
            // readonly:this.propertiesfield[droppedField.labelname].readonly,
            // required: this.propertiesfield[droppedField.labelname].required,
            derivedfield: false,
            active: true,
            groupfieldattributes: {},
            // groupfieldattributes:this.groupfieldattributes,
            createddate: "2023-06-05 17:41:39.821061"
          };

          if (this.propertiesField.hasOwnProperty(droppedField.fieldname)) {
            const fieldProperties =
              this.propertiesField[droppedField.fieldname];
            // Assign readonly and required from fieldProperties
            // metaGroupField.readonly = fieldProperties.readonly;
            // metaGroupField.required = fieldProperties.required;
            metaGroupField.readonly =
              fieldProperties !== undefined ? fieldProperties.readonly : false;
            metaGroupField.required =
              fieldProperties !== undefined ? fieldProperties.required : false;
          } else {
            const fieldProperties = this.groupFields[droppedField.fieldname];
            // metaGroupField.readonly = fieldProperties.readonly;
            // metaGroupField.required = fieldProperties.required;
            metaGroupField.readonly =
              fieldProperties !== undefined ? fieldProperties.readonly : false;
            metaGroupField.required =
              fieldProperties !== undefined ? fieldProperties.required : false;
          }
          var metaGroupFieldAttributes = {};
          if (droppedField.fieldname) {
            // console.log("droppedField.labelname");
            metaGroupFieldAttributes = {
              recordtypeexist: "",
              object: "",
              linkfield: "",
              hidden: false,
              linkrelativeurl: "",
              islink: false,
              headerfields: false,
              hiddenonnew: false,
              hiddenonedit: false,
              onnew: true,
              onedit: true,
              sequence: 0,
              lockedonedit: false,
              lockedonnew: false
              // autofillsource: "",
            };
          }
          if (droppedField.fieldtype.toLowerCase() == "id") {
            metaGroupFieldAttributes = {
              recordtypeexist: "false",
              object: "",
              linkfield: "",
              hidden: true,
              linkrelativeurl: "",
              islink: false,
              headerfields: false,
              hiddenonnew: false,
              hiddenonedit: false,
              onnew: true,
              onedit: true,
              sequence: 0,
              lockedonedit: false,
              lockedonnew: false
              // autofillsource: "",
            };
          }
          // else if (droppedField.fieldname.toLowerCase() == "name") {
          //   //var linkrelativeurl = 'web/v1/' + this.metaobjectName + '/leadview';
          //   var linkrelativeurl = "dv/" + this.metaobjectName;
          //   metaGroupFieldAttributes = {
          //     recordtypeexist: "" + hasRecordType,
          //     object: this.metaobjectName,
          //     linkfield: "id",
          //     hidden: false,
          //     linkrelativeurl: linkrelativeurl,
          //     islink: true,
          //     headerfields: true,
          //     sequence:1

          //   };
          // }
          //  else if (Object.keys(this.groupfieldattributes).length >0) {
          else if (this.groupfieldAttributes[droppedField.fieldname]) {
            // console.log(this.groupfieldattributes);
            // console.log(droppedField);
            const savedGroupFieldAttributes =
              this.groupfieldAttributes[droppedField.fieldname];
            metaGroupFieldAttributes = {
              ...savedGroupFieldAttributes,
              hiddenonnew:
                savedGroupFieldAttributes.hiddenonnew != null
                  ? savedGroupFieldAttributes.hiddenonnew
                  : false,
              hiddenonedit:
                savedGroupFieldAttributes.hiddenonedit != null
                  ? savedGroupFieldAttributes.hiddenonedit
                  : false,
              onnew:
                savedGroupFieldAttributes.onnew != null
                  ? savedGroupFieldAttributes.onnew
                  : true,
              onedit:
                savedGroupFieldAttributes.onedit != null
                  ? savedGroupFieldAttributes.onedit
                  : true
            };
          } else {
            metaGroupFieldAttributes = {
              recordtypeexist: "",
              object: "",
              linkfield: "",
              hidden: false,
              linkrelativeurl: "",
              islink: false,
              headerfields: false,
              hiddenonnew: false,
              hiddenonedit: false,
              onnew: true,
              onedit: true,
              sequence: 0,
              lockedonedit: false,
              lockedonnew: false
              // autofillsource: "",
            };
          }

          /*
          else if (Object.keys(this.groupfieldattributes) === undefined) {
            metaGroupFieldAttributes = {
              recordtypeexist: "",
              object: "",
              linkfield: "",
              hidden: false,
              linkrelativeurl: "",
              islink: false,
            };
          }
           */

          metaGroupField.groupfieldattributes = metaGroupFieldAttributes;
          metaLayoutGroup.metalayoutgroupfields.push(metaGroupField);
          index++;
        });
        console.log(this.sectionsData);
        // if (this.mode.toLocaleLowerCase() == "edit") {
        //   const arrTranslatedGroupLayouts = [];
        //   for (let translatedLayoutGroupLabel of this.sectionsData.translategroup) {
        //     const layoutGroupLabelTranslation = {
        //       id: this.guid.getGUID("metalayoutgrouplabeltranslation"),
        //       organizationid: localStorage.getItem("crm_orgid"),
        //       metalayoutgroupid: this.metaLayoutGroupIdSection,
        //       languagecode: translatedLayoutGroupLabel.languageCode,
        //       translatedlabel: translatedLayoutGroupLabel.translatedName,
        //       active: true,
        //     };

        //     // Push it to the array
        //     arrTranslatedGroupLayouts.push(layoutGroupLabelTranslation);
        //   }
        //   postOption.data.metalayout.layoutgrouplabeltranslation =
        //     arrTranslatedGroupLayouts;
        // }

        // metaLayoutGroup.metalayoutgroupfields = metaLayoutGroup.metalayoutgroupfields.concat(section.droppedDataFieldList);

        // if (this.mode.toLocaleLowerCase() == "edit") {
        //   if (this.sectionsData && Array.isArray(this.sectionsData)) {
        //     const arrTranslatedGroupLayouts = [];
        //     for (let grpsection of this.sectionsData) {
        //       for (let translatedLayoutGroupLabel of grpsection.translategroup) {
        //         const layoutGroupLabelTranslation = {
        //           id: this.guid.getGUID("metalayoutgrouplabeltranslation"),

        //           organizationid: localStorage.getItem("crm_orgid"),
        //           metalayoutgroupid: this.metaLayoutGroupIdSection,
        //           languagecode: translatedLayoutGroupLabel.languageCode,
        //           translatedlabel: translatedLayoutGroupLabel.translatedName,
        //           active: true,
        //         };
        //         // Push it to the array
        //         arrTranslatedGroupLayouts.push(layoutGroupLabelTranslation);
        //       }
        //     }
        //     postOption.data.metalayout.layoutgrouplabeltranslation =
        //       arrTranslatedGroupLayouts;
        //   } else {
        //     console.error("Invalid or undefined 'sectionsData'");
        //   }
        // }

        // console.log("SectionList:", this.sectionList);

        postOption.data.metalayout.metalayoutgroups.push(metaLayoutGroup);
      });

      if (this.mode.toLocaleLowerCase() == "edit") {
        if (this.sectionsData) {
          if (this.sectionsData && Array.isArray(this.sectionsData)) {
            const arrTranslatedGroupLayouts = [];

            this.sectionsData.forEach((sectionData) => {
              const matchingSection = this.sectionList.find(
                (section) => section.sectionName === sectionData.sectionName
              );

              if (matchingSection) {
                const matchingMetaLayoutGroup =
                  postOption.data.metalayout.metalayoutgroups.find(
                    (group) => group.name === sectionData.sectionName
                  );

                if (matchingMetaLayoutGroup) {
                  sectionData.translategroup.forEach(
                    (translatedLayoutGroupLabel) => {
                      const layoutGroupLabelTranslation = {
                        id: this.guid.getGUID(
                          "metalayoutgrouplabeltranslation"
                        ),
                        organizationid: localStorage.getItem("crm_orgid"),
                        metalayoutid: this.metalayoutId,
                        metalayoutgroupid: matchingMetaLayoutGroup.id, // Use the matching metaLayoutGroupId
                        languagecode: translatedLayoutGroupLabel.languageCode,
                        translatedlabel:
                          translatedLayoutGroupLabel.translatedName,
                        active: true
                      };
                      arrTranslatedGroupLayouts.push(
                        layoutGroupLabelTranslation
                      );
                    }
                  );
                }
              }
            });

            postOption.data.metalayout.layoutgrouplabeltranslation =
              arrTranslatedGroupLayouts;
          } else {
            console.error("Invalid or undefined 'sectionsData'");
          }
        }

        console.log("SectionList:", this.sectionList);
      }
    }

    var metaLayoutButtonId = "";
    var metaLayoutButton;
    //metalayoutbutton
    metaLayoutButtonId = this.guid.getGUID("metalayoutbutton");
    console.log("metaLayoutButtonId", metaLayoutButtonId);

    if (this.droppedDataButtonList) {
      this.droppedDataButtonList.forEach((button) => {
        console.log(button);
        metaLayoutButtonId = this.guid.getGUID("metalayoutbutton");
        metaLayoutButton = {
          id: metaLayoutButtonId,
          metaobjectid: this.metaobjectId,
          metaobjectname: this.metaobjectName,
          embeddedobject: false,
          parentobjectid: "",
          metalayoutid: this.metalayoutId,
          metalayoutname: this.metalayoutName,
          labelname: button.labelname,
          name: button.name,
          metabuttonid: button.id,
          description: button.description,
          buttontype: button.buttontype,
          actiontype: button.actiontype,
          active: "true",
          attributes: button.attributes
        };
        // console.log("buttonnn", button);

        if (metaLayoutButton) {
          postOption.data.metalayout.metalayoutbuttons.push(metaLayoutButton);
        }
      });

      //****** metaprofilelayout  *********/

      //metaprofilelayoutweb
      this.metaProfileLayoutWebId = this.guid.getGUID("metaprofilelayoutweb");

      var metaProfileLayoutWeb = {
        id: this.metaProfileLayoutWebId,
        metaobjectid: this.metaobjectId,
        metaobjectname: this.metaobjectName,
        embeddedobject: false,
        parentobjectid: "",
        metalayoutid: this.metalayoutId,
        metalayoutname: this.metalayoutName,
        recordtypeid: null,
        recordtypename: "",
        profileid: null,
        profilename: "",
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        description: "",
        actiontype: "New",
        active: true,
        layouttype: "Page Layout",
        layoutjsontext: {},
        fieldjsontext: {},
        criteriajsontext: {}
      };

      //push metaprofilelayout to request data (postoption)
      // postOption.data.metalayout.metaprofilelayoutwebs.push(
      //   metaProfileLayoutWeb
      // );
      // postOption.data.metalayout.metaprofilelayoutwebs =
      //   this.metaProfileLayoutWebs;
      // if (this.mode.toLocaleLowerCase() == "new") {
      //   postOption.data.metalayout.metaprofilelayoutwebs.push(
      //     metaProfileLayoutWeb,
      //   );
      // } else {
      //   // If in edit mode, we need to sanitize the existing metaProfileLayoutWebs
      //   // Clone and sanitize the large array
      //   const sanitizedMetaProfileLayoutWebs = this.metaProfileLayoutWebs.map(
      //     (item) => ({
      //       ...item,
      //       actiontype: "New",
      //       layouttype: "Page Layout",

      //       layoutjsontext: {},
      //       fieldjsontext: {},
      //       criteriajsontext: {},
      //     }),
      //   );

      //   // Assign sanitized array to the payload
      //   postOption.data.metalayout.metaprofilelayoutwebs =
      //     sanitizedMetaProfileLayoutWebs;
      // }

      if (this.mode.toLocaleLowerCase() === "new") {
        postOption.data.metalayout.metaprofilelayoutwebs.push(
          metaProfileLayoutWeb
        );
      } else {
        if (
          this.metaProfileLayoutWebs &&
          this.metaProfileLayoutWebs.length > 0
        ) {
          // sanitize existing data
          const sanitizedMetaProfileLayoutWebs = this.metaProfileLayoutWebs.map(
            (item) => ({
              ...item,
              actiontype: "New",
              layouttype: "Page Layout",
              layoutjsontext: {},
              fieldjsontext: {},
              criteriajsontext: {}
            })
          );

          postOption.data.metalayout.metaprofilelayoutwebs =
            sanitizedMetaProfileLayoutWebs;
        } else {
          // edit mode but empty array → fallback
          postOption.data.metalayout.metaprofilelayoutwebs.push(
            metaProfileLayoutWeb
          );
        }
      }

      console.log("postOption End", postOption);

      console.log(this.droppedDataRelatedList);
      // console.log(this.relatedFields);
      console.log(this.droppedDataRelatedList.length);
      // if (this.relatedFields) {
      var relatedSequence = 1;
      this.droppedDataRelatedList.forEach((relatedFields) => {
        console.log(relatedFields);

        this.metaRelatedLayoutId = this.guid.getGUID("metarelatedlayout");
        var metaRelatedLayout = {
          id: this.metaRelatedLayoutId,
          metaobjectid: relatedFields.metaobjectid,
          embeddedobject: false,
          parentobjectid: this.metaobjectId,
          virtualobject: false,
          virtualmethod: "",
          metalayoutid: this.metalayoutId,
          metalayoutname: this.metalayoutName,
          metaobjectname: relatedFields.metaobjectname,
          parentobjectname: this.metaobjectName,
          name: relatedFields.childrelationshipname,
          labelname: relatedFields.relatedlistlabel,
          displayname: relatedFields.childrelationshipname,
          attributes: relatedFields.attributes,
          targeturl: "",
          location: relatedFields.location,
          viewtype: relatedFields.viewtype,
          sortfield: relatedFields.sortfield || "",
          sortorder: relatedFields.sortorder || "ASC",
          uploadtype: relatedFields.uploadtype || "",
          enableversioning: relatedFields.enableversioning || false,
          relatedgroupname: relatedFields.relatedgroupname || "",
          linkedobject: relatedFields.linkedobject || false,
          contrafield: relatedFields.contrafield || "",
          contrareferencefields: relatedFields.contrareferencefields || "",
          iconname: relatedFields.iconname,
          fieldname: relatedFields.fieldname,
          referencefieldname: relatedFields.fieldname,
          fieldid: relatedFields.fieldid,
          sequence: relatedSequence,
          relatedobjectid: relatedFields.metaobjectid,
          // sortfield: "",
          // sortorder: "ASC",
          active: "true",
          metarelatedlayoutfield: [],
          metarelatedlayoutbutton: [],
          relatedfilter: []
        };

        console.log("metaRelatedLayout", metaRelatedLayout);

        postOption.data.metarelatedlayout.push(metaRelatedLayout);
        relatedSequence++;

        // var index = 1;

        // console.log(relatedFields);

        relatedFields.selectedLookupFields.forEach(
          (fields: any, index: number) => {
            var metarelatedField = {
              id: this.guid.getGUID("metarelatedlayoutfield"),
              metaobjectid: fields.metaobjectid,
              embeddedobject: true,
              parentobjectid: this.metaobjectId,
              virtualobject: false,
              metarelatedlayoutid: this.metaRelatedLayoutId,
              metalayoutid: this.metalayoutId,
              // metagroupid: this.metaLayoutGroupIdSection,
              metafieldid: fields.id,
              metafieldname: fields.fieldname,
              metafieldtype: fields.fieldtype,
              labelname: fields.labelname,
              attributes: fields.attributes,

              sequence: index,

              active: true
            };

            metaRelatedLayout.metarelatedlayoutfield.push(metarelatedField);
            // relatedSequence++;
          }
        );

        relatedFields.selectedLookupButtons.forEach(
          (buttons: any, index: number) => {
            // console.log(buttons);
            // var relatedButtonUrl = "/recm/" +
            // var targetURL = "api/v1/" + this.metaobjectName + "/metalayout/new";
            var relatedButtonUrl: string;
            if (buttons.name == "New") {
              relatedButtonUrl =
                "related/" + relatedFields.metaobjectname + "/new";
            } else if (buttons.name == "Edit") {
              relatedButtonUrl =
                // "/erp/v1/:appmode/dv/" + relatedFields.metaobjectname;
                "view/related/edit";
            } else if (buttons.name == "ViewAll") {
              relatedButtonUrl =
                "/v1/:appmode/lv/" + this.metaobjectName + "/related";
            } else if (buttons.name == "ViewDetail") {
              relatedButtonUrl =
                "/v1/:appmode/dv/" + relatedFields.metaobjectname;
            } else if (buttons.name == "ChangeStatus") {
              relatedButtonUrl =
                "/v1/:appmode/dv/" + relatedFields.metaobjectname;
            } else if (buttons.name == "AddAdmissionTeamMembers") {
              relatedButtonUrl =
                "related/" + relatedFields.metaobjectname + "/new/true";
            } else {
              relatedButtonUrl = "recm/" + relatedFields.name;
            }
            var metarelatedButton = {
              id: this.guid.getGUID("metarelatedlayoutbutton"),
              metabuttonid: buttons.id,
              metaobjectid: buttons.metaobjectid,
              embeddedobject: true,
              parentobjectid: this.metaobjectId,
              virtualobject: false,
              metarelatedlayoutid: this.metaRelatedLayoutId,
              metalayoutid: this.metalayoutId,
              name: buttons.name,
              description: buttons.description,
              labelname: buttons.labelname,
              buttontype: buttons.buttontype,
              actiontype: buttons.actiontype,
              sequence: index,
              targeturl: relatedButtonUrl,
              active: true,
              attributes: buttons.attributes
            };

            metaRelatedLayout.metarelatedlayoutbutton.push(metarelatedButton);
            // index = +1;
            index++;
          }
        );

        this.metaRelatedViewLayoutId = this.guid.getGUID(
          "metarelatedviewlayout"
        );

        var metaRelatedViewLayout = {
          id: this.metaRelatedViewLayoutId,
          metarelatedlayoutid: this.metaRelatedLayoutId,
          metaobjectid: relatedFields.metaobjectid,
          embeddedobject: false,
          parentobjectid: this.metaobjectId,
          virtualobject: false,
          virtualmethod: "",
          metalayoutid: this.metalayoutId,
          metalayoutname: this.metalayoutName,
          metaobjectname: relatedFields.metaobjectname,
          parentobjectname: this.metaobjectName,
          name: relatedFields.childrelationshipname,
          labelname: relatedFields.relatedlistlabel,
          displayname: relatedFields.childrelationshipname,
          referencefieldname: relatedFields.fieldname,
          targeturl: "",
          location: relatedFields.location,
          viewtype: relatedFields.viewtype,
          uploadtype: relatedFields.uploadtype,
          enableversioning: relatedFields.enableversioning,
          linkedobject: relatedFields.linkedobject,
          contrafield: relatedFields.contrafield,
          contrareferencefields: relatedFields.contrareferencefields,
          relatedgroupname: relatedFields.relatedgroupname,
          iconname: relatedFields.iconname,
          fieldname: relatedFields.fieldname,
          fieldid: relatedFields.fieldid,
          sequence: 1,
          relatedobjectid: relatedFields.metaobjectid,
          sortfieldid: "",
          sortorder: "ASC",
          active: "true",
          relatedlayoutfield: [],
          relatedlayoutbutton: []
        };

        console.log("metaRelatedViewLayout", metaRelatedViewLayout);

        postOption.data.metarelatedviewlayout.push(metaRelatedViewLayout);

        if (relatedFields.selectedViewFields.length > 0) {
          relatedFields.selectedViewFields.forEach(
            (viewfields: any, index: number) => {
              var metarelatedviewField = {
                id: this.guid.getGUID("metarelatedviewlayoutfield"),
                metaobjectid: viewfields.metaobjectid,
                embeddedobject: true,
                parentobjectid: this.metaobjectId,
                virtualobject: false,
                metarelatedviewlayoutid: this.metaRelatedViewLayoutId,
                metarelatedlayoutid: this.metaRelatedLayoutId,
                metalayoutid: this.metalayoutId,
                // metagroupid: this.metaLayoutGroupIdSection,
                metafieldid: viewfields.id,
                metafieldname: viewfields.fieldname,
                metafieldtype: viewfields.fieldtype,
                labelname: viewfields.labelname,
                attributes: {},
                sequence: index,
                active: true
              };

              metaRelatedViewLayout.relatedlayoutfield.push(
                metarelatedviewField
              );

              // relatedSequence++;
            }
          );
        } else {
          this.showWarning(
            "You must have atleast one field in the view all list (" +
              relatedFields.metaobjectname +
              ")"
          );
          noError = false;
          return;
        }

        if (relatedFields.selectedViewButtons.length > 0) {
          relatedFields.selectedViewButtons.forEach(
            (viewbuttons: any, index: number) => {
              // var relatedButtonUrl = "/recm/" +
              // var targetURL = "api/v1/" + this.metaobjectName + "/metalayout/new";
              var relatedButtonUrl: string;

              if (viewbuttons.name == "New") {
                relatedButtonUrl =
                  "/v1/:appmode/lv/" + this.metaobjectName + "/related";
              } else if (viewbuttons.name == "Edit") {
                relatedButtonUrl = "recm/" + this.metaobjectName + "/:id/edit";
              } else {
                relatedButtonUrl = "recm/" + this.metaobjectName;
              }
              var metarelatedviewButton = {
                id: this.guid.getGUID("metarelatedviewlayoutbutton"),
                metaobjectid: viewbuttons.metaobjectid,
                metabuttonid: viewbuttons.id,
                embeddedobject: true,
                parentobjectid: this.metaobjectId,
                virtualobject: false,
                metarelatedviewlayoutid: this.metaRelatedViewLayoutId,
                metarelatedlayoutid: this.metaRelatedLayoutId,
                metalayoutid: this.metalayoutId,
                name: viewbuttons.name,
                description: viewbuttons.description,
                labelname: viewbuttons.labelname,
                buttontype: viewbuttons.buttontype,
                actiontype: viewbuttons.actiontype,
                sequence: index,
                targeturl: relatedButtonUrl,
                active: true,
                attributes: viewbuttons.attributes
              };

              metaRelatedViewLayout.relatedlayoutbutton.push(
                metarelatedviewButton
              );

              // index++;
            }
          );
        } else {
          this.showWarning("You must have atleast one button in the view all");
          noError = false;
          return;
        }
        if (
          relatedFields.hasOwnProperty("relatedFilters") &&
          relatedFields.relatedFilters != undefined &&
          relatedFields.relatedFilters != null &&
          relatedFields.relatedFilters.length > 0
        ) {
          // if (relatedFields.relatedFilters.length > 0) {
          relatedFields.relatedFilters.forEach((filter: any, index: number) => {
            var metarelatedFilter = {
              id: this.guid.getGUID("metarelatedfilter"),
              metarelatedlayoutid: this.metaRelatedLayoutId,
              metaobjectid: filter.metaobjectid,
              metalayoutid: this.metalayoutId,
              metafieldid: filter.metafieldid,
              metafieldname: filter.fieldname,
              metafieldtype: filter.fieldtype,
              labelname: filter.labelname,
              operator: filter.operator,
              value: filter.value,
              filterlogic: filter.filterlogic,
              attributes: {},
              sequence: index,
              active: true
            };

            metaRelatedLayout.relatedfilter.push(metarelatedFilter);

            // relatedSequence++;
          });
        }
        // }
      });

      this.isLoading = true;

      if (this.mode.toLocaleLowerCase() == "edit") {
        if (this.translatedLabels) {
          var arrtranslatedLayouts = [];
          for (let translatedlayoutlabel of this.translatedLabels) {
            var layoutlabelTranslation = {
              id: this.guid.getGUID("metalayoutlabeltranslation"),
              organizationid: localStorage.getItem("crm_orgid"),
              metalayoutid: this.metalayoutId,
              languagecode: translatedlayoutlabel.languageCode,
              translatedlabel: translatedlayoutlabel.translatedName,
              active: true
            };

            //push it to array
            arrtranslatedLayouts.push(layoutlabelTranslation);
          }
          postOption.data.metalayout.layoutlabeltranslation =
            arrtranslatedLayouts;
        }
      }

      console.log(postOption);

      if (noError) {
        this.dataService.layoutData(postOption).subscribe(
          (res) => {
            //alert('****res****' + JSON.stringify(res));
            console.log(res);
            if (res.success == 1) {
              this.showSuccess(res.message);
              this.isLoading = false;
              this.router.navigateByUrl(
                "/home/metaobjectdetail/" +
                  this.metaobjectId +
                  "/" +
                  this.metaobjectName
              );
            } else {
              console.log("error while saving");
              this.showError(res.message);
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.showError(err.message);
            this.isError = true;
            this.isLoading = false;
          }
        );
      }

      console.log(
        "URL:",
        this.appConfig.config.ipaddress + ":47000/api/v1/metalayout/upsert"
      );
    }
  }
}
